import { render, staticRenderFns } from "./App.vue?vue&type=template&id=aa00a51a"
var script = {}
import style0 from "./App.vue?vue&type=style&index=0&id=aa00a51a&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_css-load_574b8669d18f67ce8fdb77c3b9cb8ea1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports